import React from "react";
import { BiCodeAlt, BiGlobe, BiTargetLock } from "react-icons/bi";

const About = () => {
  return (
    <section
      id="about"
      className="relative scroll-mt-36 py-20 md:py-32 bg-yellow overflow-hidden"
    >
            <div className="absolute z-10 bottom-0 rotate-180 left-0 w-full overflow-hidden leading-none">
        <svg
          className="relative block w-full h-12"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            className="fill-blue"
          ></path>
        </svg>
      </div>
      <div className="mx-auto px-6 md:px-12 relative z-10">
        <div className="max-w-7xl mx-auto">
          {/* Section Title */}
          <div className="text-start mb-12">
            <h2 className="text-4xl md:text-5xl font-semibold text-blue mb-4 uppercase tracking-wide">
              عن الهاكاثون
            </h2>
            <div className="w-24 h-1 bg-main-green me-auto rounded-full"></div>
          </div>

          {/* Content Card */}
          <div className="rounded-3xl p-8 md:p-12 transition-all ">
            <div className="space-y-6 text-right">
              <p className="text-lg md:text-xl text-blue leading-relaxed">
                قمة هاكاثون هو فعالية تقنية تجمع المطورين العرب لبناء أدوات
                ومشاريع مفتوحة المصدر تعزز حضور اللغة العربية في عالم البرمجة.
              </p>

              <p className="text-lg md:text-xl text-blue leading-relaxed">
                نؤمن أن المبرمج العربي قادر على الإبداع، وأن بناء أدوات تخدم
                مجتمعه هو خطوة نحو اكتفاء تقني ومعرفي عربي.
              </p>

              <p className="text-lg md:text-xl text-blue font-semibold leading-relaxed">
                هذا الحدث ليس مجرد منافسة، بل حركة نحو تمكين المحتوى التقني
                العربي.
              </p>
            </div>

            {/* Feature Highlights */}
            <div className="grid md:grid-cols-3 gap-6 mt-12">
              <div className="text-start p-6 bg-blue hover:scale-105 rounded-2xl transition-all ">
                <div className="text-4xl text-yellow mb-3">
                  <BiGlobe />
                </div>
                <h3 className="text-xl font-semibold text-white mb-2">عن بُعد</h3>
                <p className="text-white/70 text-sm">
                  شارك من أي مكان في العالم العربي
                </p>
              </div>

              <div className="text-start p-6 bg-dark-blue hover:scale-105 rounded-2xl transition-all ">
                <div className="text-4xl text-yellow mb-3">
                  <BiCodeAlt />
                </div>
                <h3 className="text-xl font-semibold text-white mb-2">
                  مفتوح المصدر
                </h3>
                <p className="text-white/70 text-sm">
                  جميع المشاريع مفتوحة للمجتمع
                </p>
              </div>

              <div className="text-start p-6 bg-main-green hover:scale-105 rounded-2xl transition-all ">
                <div className="text-4xl text-yellow mb-3">
                  <BiTargetLock />
                </div>
                <h3 className="text-xl font-semibold text-white mb-2">
                  للمبرمجين العرب
                </h3>
                <p className="text-white/70 text-sm">نبني أدوات تخدم مجتمعنا</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
